import { Link } from 'react-router-dom';
import { quickFacts } from '@/mocks/home';

export default function HomeCta() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20graphic%20of%20flowing%20terracotta%20and%20amber%20paper%20ribbons%20with%20a%20glowing%20envelope%20shape%2C%20deep%20warm%20gradient%2C%20editorial%20poster%20art%2C%20textured%20grain%2C%20dramatic%20lighting%2C%20no%20legible%20text%2C%20no%20people&width=1600&height=760&seq=gossip-cta-01&orientation=landscape"
          alt="17吃瓜网投稿入口的抽象暖色信封背景图"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/78"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-3xl">
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-background-50">
            线索在你手上，核实交给我们
          </h2>
          <p className="mt-5 text-base leading-8 text-background-100/90 max-w-xl">
            进入投稿入口，用三分钟把你知道的写下来。是匿名还是留联系方式，由你决定。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md bg-accent-500 text-foreground-950 text-base font-bold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-fill text-lg"></i>
              我要投稿
            </Link>
            <Link
              to="/guide"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md bg-background-50/12 text-background-50 text-base font-medium border border-background-50/35 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-question-line text-lg"></i>
              投稿指南
            </Link>
          </div>

          <dl className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl">
            {quickFacts.map((f) => (
              <div key={f.label} className="flex items-start gap-3">
                <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-background-50/12 text-accent-400">
                  <i className={`${f.icon} text-lg`}></i>
                </span>
                <span className="flex flex-col">
                  <dt className="text-xs text-background-300">{f.label}</dt>
                  <dd className="text-sm font-bold text-background-50 mt-0.5">{f.value}</dd>
                </span>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}